import React from "react"

import Board_ShowTotal_OptionColumns from "./option/option-columns"
import Board_ShowTotal_OptionRows from "./option/option-rows"
import Board_Manager from "../../../managers/manager"
import Board_GroupBy from "../../../managers/group-by/group-by"

type Props = {
    manager     : Board_Manager
    hidePopover : callback
}

// const debug = "Board_ColumnHeader_ShowTotal"
const debug = false

export default function Board_ColumnHeader_ShowTotal(props:Props) {

    const groupBy = props.manager.groupBy as Board_GroupBy

    const classes = Classes("flex-column-left-top m-b-10", {
        'w-450': groupBy.isRowsAndColumns,
        'w-350': !groupBy.isRowsAndColumns
    })

    return (
        <div className={classes}>
            <div className="ui5-title-smaller-dark txt-semibold m-l-20 m-t-20 m-b-15">
                Summary
            </div>

            <Board_ShowTotal_OptionColumns manager={props.manager}/>
            <Board_ShowTotal_OptionRows manager={props.manager}/>
        </div>
    )
}